module.exports = __webpack_public_path__ + "media/pricing/Health_Screening-dd467699.svg";